import React, { useEffect, useState } from 'react';
import History from '../../../Header/HeaderRightMenu/InfoSubComponents/History';
import InvoiceTogel from '../../../Header/HeaderRightMenu/InfoSubComponents/InvoiceTogel';
import MemberList from '../../../Header/HeaderRightMenu/InfoSubComponents/MemberList';
import BonusReferral from '../../../Header/HeaderRightMenu/InfoSubComponents/BonusReferral';
import BonusEvent from '../../../Header/HeaderRightMenu/InfoSubComponents/BonusEvent';
import InfoTurnover from '../../../Header/HeaderRightMenu/InfoSubComponents/InfoTurnover';
import Pagination from '../../../LobbyContent/SubComponents/Pagination';
import { dataEntryPerPage, setPaginationData } from '../../../../redux/actions';
import LeftArrow from "../../../../assets/images/Icons/icons/left_arrow.svg";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { MdOutlineArrowBackIos } from "react-icons/md";

const InformationMoDesign = (props) => {

  const dispatch = useDispatch()

  const [resetPage, setResetPage] = useState(false);

  const [perPage, setPerPage] = useState(10);
  const [selectedTab, setSelectedTab] = useState("History");
  const navigate = useNavigate();
  // Function to handle tab change

  const renderComponent = () => {
    switch (selectedTab) {
      case "History":
        return <History handlePageNo={handlePageNo} />;
      case "InvoiceTogel":
        return <InvoiceTogel />;
      case "MemberList":
        return <MemberList />;
      case "BonusReferral":
        return <BonusReferral />;
      case "InfoTurnover":
        return <InfoTurnover />;
      case "BonusEvent":
        return <BonusEvent />;
      default:
        return null;
    }
  };

  const handleTabClick = (tabName, e) => {
    // Prevent event propagation to parent elements
    e.stopPropagation();
    setSelectedTab(tabName);
    dispatch(setPaginationData(tabName))

  };

  const handlePageNo = () => {
    setResetPage(true);
    window.scrollTo(0, 0)
  };

  const handleResetPageNo = () => {
    setResetPage(false);
  };


  const handlePerRowsChange = (e) => {
    const perPageValue = e.target.value;
    setPerPage(perPageValue);
    setResetPage(true);
  };


  useEffect(() => {
    setPerPage(10);
  }, [selectedTab]);

  dispatch(dataEntryPerPage(perPage))


  return (
    <div className='main_contain information_mo'>
      <div className="pages_topbar">
        <div className="back_arrow" onClick={() => navigate("/")}>
        <MdOutlineArrowBackIos />
        </div>
        <div className="page_heading">
          <h2>{props.t('information')}</h2>
        </div>
      </div>
      <div className="tabs_select_row">
        <div className="tabs">
          <button
            className={selectedTab === "History" ? "tab active" : "tab"}
            onClick={(e) => handleTabClick("History", e)}
          >
            {props.t('transaction')}
          </button>
          <button
            className={selectedTab === "InvoiceTogel" ? "tab active" : "tab"}
            onClick={(e) => handleTabClick("InvoiceTogel", e)}
          >
            {"Invoice Togel"}
          </button>
          <button
            className={
              selectedTab === "MemberList" ? "tab active" : "tab"
            }
            onClick={(e) => handleTabClick("MemberList", e)}
          >
            {props.t('member_list')}
          </button>
          <button
            className={
              selectedTab === "BonusReferral" ? "tab active" : "tab"
            }
            onClick={(e) => handleTabClick("BonusReferral", e)}
          >
            {props.t('bonus_referral')}
          </button>
          <button
            className={
              selectedTab === "InfoTurnover" ? "tab active" : "tab"
            }
            onClick={(e) => handleTabClick("InfoTurnover", e)}
          >
            {props.t('info_turnover')}
          </button>
          <button
            className={selectedTab === "BonusEvent" ? "tab active" : "tab"}
            onClick={(e) => handleTabClick("BonusEvent", e)}
          >
            {props.t('bonus_event')}
          </button>
        </div>
        <select
          className="dropdown"
          onChange={handlePerRowsChange}
          value={perPage}
        >
          <option value={10}>{10}</option>
          <option value={25}>{25}</option>
          <option value={50}>{50}</option>
          <option value={100}>{100}</option>
        </select>
      </div>
      <div>{renderComponent()}</div>
      {selectedTab !== "InvoiceTogel" && (
        <Pagination resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
      )}
    </div>
  );
};

export default withTranslation()(InformationMoDesign);
